import { render, staticRenderFns } from "./Acategory.vue?vue&type=template&id=34ac4b44&scoped=true&"
import script from "./Acategory.vue?vue&type=script&lang=js&"
export * from "./Acategory.vue?vue&type=script&lang=js&"
import style0 from "./Acategory.vue?vue&type=style&index=0&id=34ac4b44&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ac4b44",
  null
  
)

export default component.exports